<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Contacts</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div>
  <div class="modal-body" hsDraggable="modal-dialog">
    <nf-grid-wrapper class="wrapperStyling" *ngIf="custodyContacts.length != 0">
      <ng-grid-wrapper-header-right class="email-all-parents">
      </ng-grid-wrapper-header-right>
      <nf-grid-wrapper-content>
        <nf-table-layout
          hideTitle
          hideSearch
          [autoResizeGrid]="false"
          [isSectionTitle]="false"
          [gridOptions]="gridOptionsContactDetails"
          [data]="custodyContacts"
          hideClearAll
        >
        </nf-table-layout>
      </nf-grid-wrapper-content>
    </nf-grid-wrapper>
    <hs-panel-card
      *ngIf="custodyContacts.length == 0"
      header="No Contacts Available"
      #noContact
    >
      <p>
        No Client Custody contact information is available for the selected
        transport Feed
      </p>
    </hs-panel-card>
  </div>
  <div
    class="modal-footer"
    hsDraggable="modal-dialog"
    *ngIf="custodyContacts.length != 0"
  >
    <a href="mailto:{{ emailsAll }}" target="_blank">Email All</a>
  </div>
</div>
